"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.skillUpRequirementsOptions = exports.skillUpRequirements = exports.wwgRequirementsIcon = exports.wwgRequirementsOptions = exports.wwgRequirements = void 0;
var map_1 = __importDefault(require("lodash/map"));
exports.wwgRequirements = [
    'High school diploma or equivalency',
    'Authorized to work in the US',
    "State ID or Driver's License",
    'Background Check',
    'Physically able to operate machinery or lift heavy objects',
    'Interview',
    'Essay',
    'Drug Test',
    'No Felony Record',
    'Standardized Test',
];
exports.wwgRequirementsOptions = (0, map_1.default)(exports.wwgRequirements, function (requirement) {
    return {
        label: requirement,
        value: requirement,
    };
});
exports.wwgRequirementsIcon = 'https://res.cloudinary.com/wherewego/image/upload/v1649344950/WWG2000%20Site%20Photos/yfe62nqvbvozptqysans.svg';
exports.skillUpRequirements = [
    "Proof of identity (state ID or driver's license)",
    'Authorized to work in the U.S.',
    'Acceptance exam',
    'High school diploma or equivalency',
    "Driver's license",
    'Background check',
    'No felony conviction',
    'Drug testing',
    'Physically able to operate heavy machinery',
];
exports.skillUpRequirementsOptions = (0, map_1.default)(exports.skillUpRequirements, function (requirement) {
    return {
        value: requirement,
        label: requirement,
    };
});
